module.exports = __webpack_public_path__ + "img/settings.59074901.jpg";